"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiSubmit from "@/components/form/UiSubmit.vue";
import Question from "@/components/Question.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
export class ChangeCodeFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.code = "";
    this.shop_name = "";
    this.color = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("change_code_dialog.please_enter"),
      trigger: "blur"
    },
    {
      validator: (rule, value, callback) => {
        if (value !== "" && value.search(/^[0-9A-Za-z]{3}$/) < 0) {
          callback(i18n.t("change_code_dialog.code_validator"));
          return false;
        }
        callback();
        return true;
      },
      trigger: "blur"
    }
  ])
], ChangeCodeFormController.prototype, "code", 2);
let ChangeCodeDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.form = new ChangeCodeFormController();
    this.shopItem = null;
    this.predefineColors = [
      "#4176bd",
      "#1e9ce2",
      "#00b5b5",
      "#0cb55d",
      "#e2ae00",
      "#ef8900",
      "#e7471b",
      "#da358c",
      "#8c5bfe",
      "#0b182c"
    ];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(item) {
    return __async(this, null, function* () {
      try {
        this.shopItem = item;
        console.log(item);
        this.form.shop_name = item.name;
        this.form.color = item.iconTag.color;
        this.form.code = item.iconTag.character;
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  changeChooseColor(choose) {
    const reg = /^(rgb|RGB)/;
    let chooseColor = "#";
    if (reg.test(choose)) {
      let colorArr = choose.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
      for (let i = 0; i < colorArr.length; i++) {
        let hex = Number(colorArr[i]).toString(16);
        if (hex.length === 1) {
          hex = "0" + hex;
        }
        chooseColor += hex;
      }
    }
    this.form.color = chooseColor.toUpperCase();
  }
  submitCode() {
    return __async(this, null, function* () {
      var _a;
      try {
        yield API.put(`api://base.auth/api/v1/shops/customize-icon/${this.shopItem.shopOldId}`, {
          color: this.form.color,
          character: this.form.code
        });
        this.$message.success(this.$t("change_code_dialog.submit_success"));
        this.shopItem = null;
        this.form.clear();
        this.$emit("refresh");
        this.dialog.visible = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error((_a = error.response.data.errors) == null ? void 0 : _a.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Debounce(800)
], ChangeCodeDialog.prototype, "submitCode", 1);
ChangeCodeDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      Question,
      UiSubmit
    }
  })
], ChangeCodeDialog);
export {
  ChangeCodeDialog as default
};
